import { Descriptions, DescriptionsProps } from "antd";
import React from "react";

interface DetailsViewLayoutProps {
  items: DescriptionsProps["items"];
  style?: React.CSSProperties;
}
function DetailsViewLayout(props: DetailsViewLayoutProps) {
  return (
    <Descriptions
      items={props.items}
      colon={false}
      column={2}
      layout="vertical"
      contentStyle={{
        paddingBottom: "var(--space-24)",
      }}
      style={props.style}
    />
  );
}

export { DetailsViewLayout };
